import reactComponentLoader from 'scripts/react-component-loader'

import { SignUpPage } from '../SignUp'

reactComponentLoader(SignUpPage, '[data-lmcv-signup]')
